import axios from 'axios';
import {
  IdProps,
  SaleCreateProps,
  SaleGetAllByClientYardQuery,
  SaleGetAllQuery,
  SaleStatsGetAllQuery,
  SaleUpdateProps,
} from '../../types';

class SaleService {
  create = (props: SaleCreateProps[]) => axios.post('/sales', props);

  getAllByClientYard = ({ path, ...props }: any) =>
    axios.get<SaleGetAllByClientYardQuery>(`/sales/${path}`, props);

  getAll = (props: any) => axios.get<SaleGetAllQuery>('/sales', props);

  getAllStats = () => axios.get<SaleStatsGetAllQuery>('/sales/stats');

  getOneVisit = (id: string) => axios.get(`/sales/${id}/visit`, { params: { notLoading: true } });

  buy = (props: IdProps[]) => axios.post('/sales/buy', props);

  update = (props: SaleUpdateProps[]) => axios.patch('/sales', props);

  delete = (props: IdProps[]) => axios.delete('/sales', { data: props });
}

export const saleService = new SaleService();
